import React from "react";
import { FaGooglePlay } from "react-icons/fa";
import plutonicLogo from "../assets/images/plutonicLogo.svg";
import plutonicName from "../assets/images/plutonicName.svg";

const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.plutonic.mobile";

const AndroidDownloadPage = () => (
  <main className="relative flex min-h-screen items-center justify-center overflow-hidden bg-gradient-to-br from-[#D8F8FF] via-white to-[#eefaff] px-5 py-10 sm:py-16">
    <div className="pointer-events-none absolute -left-24 top-16 h-72 w-72 rounded-full bg-[#22AAEE]/10 blur-3xl" />
    <div className="pointer-events-none absolute -right-24 bottom-10 h-80 w-80 rounded-full bg-cyan-200/30 blur-3xl" />

    <section className="relative w-full max-w-lg overflow-hidden rounded-[2rem] border border-white/80 bg-white/95 p-7 text-center shadow-[0_24px_70px_rgba(24,135,189,0.18)] sm:p-12">
      <div className="mb-8 flex items-center justify-center gap-3">
        <img src={plutonicLogo} alt="" className="h-14 w-20 object-contain sm:h-16 sm:w-24" />
        <img src={plutonicName} alt="Plutonic" className="h-9 w-36 object-contain sm:h-10 sm:w-40" />
      </div>

      <p className="mb-3 text-sm font-bold uppercase tracking-[0.2em] text-[#1687bd]">
        Plutonic for Android
      </p>
      <p className="mx-auto mt-4 max-w-md text-base leading-relaxed text-gray-600 sm:text-lg">
        Join your Plutonic therapy sessions from a compatible Android phone or
        tablet with the secure Plutonic mobile app.
      </p>

      <a
        href={GOOGLE_PLAY_URL}
        className="relative mt-9 inline-flex min-h-14 w-full items-center justify-center rounded-full bg-[#22AAEE] px-16 py-3 text-center text-lg font-semibold text-white shadow-lg shadow-sky-200 transition hover:-translate-y-0.5 hover:bg-[#1687bd] focus:outline-none focus:ring-4 focus:ring-sky-200"
      >
        <FaGooglePlay aria-hidden="true" className="absolute left-6 h-7 w-7" />
        <span className="w-full text-center">Get Plutonic on Google Play</span>
      </a>

      <div className="mt-8 grid grid-cols-3 gap-3 border-t border-sky-100 pt-7 text-sm font-semibold text-gray-700">
        <div className="rounded-2xl bg-sky-50 px-2 py-3">Secure sessions</div>
        <div className="rounded-2xl bg-sky-50 px-2 py-3">Virtual spaces</div>
        <div className="rounded-2xl bg-sky-50 px-2 py-3">Android ready</div>
      </div>

    </section>
  </main>
);

export default AndroidDownloadPage;
